import React from 'react';

// constants
import { EmployeeInformationColumnWidth, TimelineHours, Timeline30MinLayoutHours, Timeline30MinLayoutColumnWidth, minuteWidth, minute30MinLayoutWidth } from '../../../../utils/timeline-constants';

// styling
import { Colors } from "_styles";

const TimelineThirtyMinHourRow = (props) => {

    const intervals = Array.from({ length: 6 }); // 6 intervals for 5-minute blocks in 30 minutes

    return (
        <div style={{ display: 'flex', position: 'sticky', top: 0, minWidth: EmployeeInformationColumnWidth, maxWidth: EmployeeInformationColumnWidth }}>

            {/* employee information spacer (need to put space between area where employees list is and where clock should start) */}
            <div style={{ minWidth: EmployeeInformationColumnWidth, maxWidth: EmployeeInformationColumnWidth }} />

            {Timeline30MinLayoutHours.map((hour, index) => (
                <div
                    key={index}
                    style={{
                        minWidth: Timeline30MinLayoutColumnWidth,
                        maxWidth: Timeline30MinLayoutColumnWidth,
                        //border: '1px solid lightgrey', 
                        padding: 0,
                        margin: 0,
                    }}
                >
                    <p style={{ textAlign: 'flex-start', color: Colors.PRM_LIGHT_BLUE, fontSize: '12px', fontWeight: 'bold', padding: 0, margin: 0, marginLeft: -16 }}>{hour}</p>

                    <div style={{ display: 'flex', border: '1px solid lightgrey' }}>
                        {intervals.map((_, idx) => (
                            <div style={{ width: minute30MinLayoutWidth * 5 }}>
                                {idx == 0 ? <p></p> :
                                    idx == 3 ? <div style={{ height: '100%', width: 1.5, backgroundColor: props?.backgroundColor ? props?.backgroundColor : 'lightgrey' }} />
                                        : <div style={{ height: '40%', width: 1.5, backgroundColor: props?.backgroundColor ? props?.backgroundColor : 'lightgrey' }} />
                                }
                            </div>
                        ))}
                    </div>

                </div>
            ))}
        </div>
    );
};

export default TimelineThirtyMinHourRow;